<template lang="pug">
  v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="datasourceRules"
    label='Athena Data source'
    data-track="datasource"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputDatasource extends Vue {
  datasourceRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Datasource is required'];
}
</script>
